<template>
  <div id="stockEdit">
    <div class="filters">
      <div class="group grow">
        <label>{{ $t('stock_edit.filter_by_type') }}</label>
        <select v-model="typeFilter.selected">
          <option :value="null">{{ $t('none_m') }}</option>
          <option :value="f" v-for="f of typeFilter.all">{{ $t(`item_type.${f}`) }}</option>
        </select>
      </div>
      <div class="group grow">
        <label>{{ $t('search') }}</label>
        <input type="text" v-model="search">
      </div>
      <div class="group">
        <label>{{ $t("showing") }}</label>
        <div class="text">{{ orderablesFiltered.length }} {{ $t("datatable.of") }} {{ orderables.length }}</div>
      </div>
    </div>
    <VirtualList :items="orderablesFiltered" :template="StockEditRow" ref="virtal" v-if="orderablesFiltered.length > 0">
      <tr>
        <th class="head shrink"></th>
        <th class="head shrink">{{ $t("type") }}</th>
        <th class="head grow">{{ $t("address.name") }}</th>
        <th class="head shrink">{{ $t("items.qty_in_stock") }}</th>
        <th class="head shrink"></th>
      </tr>
    </VirtualList>
  </div>
</template>

<script>
  import { Core } from '@/core/Core';
  import VirtualList from "@/components/tools/VirtualList.vue";
  import StockEditRow from './StockEditRow.vue';

  export default {
    name: "StockEdit",

    components: { VirtualList },

    data() {
      return {
        inventory: null,
        orderables: [],
        search: '',
        typeFilter: {
          selected: null,
          all: [
            'item',
            'variant',
            'modifier',
            'combo',
            'supplement'
          ]
        },
        StockEditRow
      }
    },

    computed: {
      company() {
        return this.$store.state.contextCompany;
      },
      inventoryReference() {
        return this.company ? this.company.nameCanonical : this.inventory.id;
      },
      orderablesFiltered() {
        let searchFragments = this.search.trim().replace(/\s\s+/g, ' ').toLowerCase().split(' ');
        let typeFilter = this.typeFilter.selected;
        let toReturn = this.orderables
          .filter(o => !typeFilter || typeFilter === o.type)
          .filter(o => searchFragments.every(fragment => o.searchString.includes(fragment)));
        return toReturn;
      },
      filter() {
        return item => {
          let searchFragments = this.search.trim().replace(/\s\s+/g, ' ').toLowerCase().split(' ');
          let typeFilter = this.typeFilter.selected;
          return (!typeFilter || typeFilter === item.type)
            && searchFragments.every(fragment => item.searchString.includes(fragment));
        }
      }
    },

    async mounted() {
      this.inventory = await this.$store.getters.getContextInventory;
      var observer = new IntersectionObserver((entries) => {
        if (this.orderables.length === 0 && entries[0].isIntersecting) {
          this.fetch();
        }
      }, { threshold: [0] });
      observer.observe(this.$el);
    },

    methods: {
      setDirty(row) {
        row.dirty = true;
      },
      async fetch() {
        let fields = ['id', 'type', 'name', 'qtyInStock', 'parentId'];
        this.$store.commit('showSpinner', true);
        let response = await Core.request('GET', `/api/inventory/${this.inventoryReference}/orderables`, { fields, noParent: true, admin: true });
        this.$store.commit('showSpinner', false);

        if (response) {
          for (let line of response) {
            line.searchString = JSON.stringify(line.name).toLowerCase();
          }
          this.orderables = response;
        }
      },
      async save() {
        let data = this.orderables
          .filter(o => !!o.dirty)
          .map(({ id, qtyInStock }) => {
            let qtyAsNumber = parseFloat(qtyInStock);
            return {
              id: id,
              qtyInStock: isNaN(qtyAsNumber) ? null : qtyAsNumber
            }
          });

        let response = await Core.request('PUT', `/api/inventory/${this.inventoryReference}/item_mass_update`, { payload: data });
        if (response) {
          for (let o of this.orderables) {
            o.dirty = false;
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .filters {
    display: flex;

    .group {
      &.grow {
        flex-grow: 1;
      }

      &:not(:last-child) {
        margin-right: 20px;
      }

      input {
        height: 41px;
      }

      .text {
        margin-top: 12px;
      }
    }
  }
</style>

<style lang="scss">
  #stockEdit {
    .page-content {
      overflow: hidden;
    }

    table {
      width: 100%;
      max-width: 100%;
      table-layout: fixed;
    }

    th,
    td {
      padding: 12px;
      overflow: hidden;
    }

    th {
      text-align: left;
      color: #808080;
      font-size: 14px;
      font-weight: normal;

      &:first-child {
        width: 56px;
      }

      &:last-child {
        width: 40px;
      }

      &.shrink {
        white-space: nowrap;
      }

      &.grow {
        word-break: break-all;
        overflow: hidden;
      }
    }

    td {
      input {
        min-width: 0;
        max-width: 100%;
      }
    }

    .icon {
      width: 32px;
      height: 32px;
      background-color: #F5F5F5;
      border-radius: 8px;
      fill: #CCCCCC;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .action {
      cursor: pointer;
      text-align: center;
      fill: var(--primary-color);
    }
  }
</style>